import { createRoot } from 'react-dom/client'

// Style order matters: reset -> tokens -> fonts.
import './styles/reset.css'
import './styles/tokens.css'
import './styles/fonts.css'

// Inter, self-hosted via @fontsource (the Flutter build pulled it from the
// google_fonts CDN at runtime). 400 covers body/label styles; 500/700 are
// used by the canvas-drawn distance callout later (M8/M9).
import '@fontsource/inter/400.css'
import '@fontsource/inter/500.css'
import '@fontsource/inter/700.css'

import './styles/animations.css'

import { RouterProvider } from 'react-router-dom'
import { FirebaseBootstrap } from './components/FirebaseBootstrap'
import { ToastProvider } from './components/ui/ToastProvider'
import { LocaleSwitcher } from './components/LocaleSwitcher'
import { locale, setLocale, localeNotifier } from './i18n'
import { useNotifier } from './lib/notifier'
import { router } from './router'

// NOTE: no <StrictMode>. Strict mode double-invokes effects in dev, which
// would double-run parity-sensitive side effects we port later (anonymous
// sign-in postFrame callback, the module-level geolocation timer). Parity
// over ceremony.
function App() {
  // Language switching (NEW feature — the original had no localization).
  // `tr` is a module binding React cannot see through, so every locale
  // change (switcher OR the alarm's optional locale hint) publishes through
  // localeNotifier; the subscription below re-keys the router subtree and
  // everything remounts with the new strings. The URL survives the remount.
  const loc = useNotifier(localeNotifier, () => locale)

  // main() order preserved: Firebase bootstrap wraps the router, mirroring
  // initFirebase() -> createRouter() -> userStream.listen in main.dart.
  // ToastProvider ~ app-level ScaffoldMessenger (sits above the Navigator).
  return (
    <FirebaseBootstrap>
      <ToastProvider>
        <div key={loc} style={{ height: '100%' }}>
          <RouterProvider router={router} />
        </div>
        <LocaleSwitcher current={loc} onChange={setLocale} />
      </ToastProvider>
    </FirebaseBootstrap>
  )
}

createRoot(document.getElementById('root')!).render(<App />)
